import { Checkbox } from 'components/Ui-Kits/Checkbox'
import { any, array, func, string } from 'prop-types'
import styled from 'styled-components'

export const FilterItem = ({ onChange, values, label, value, childrenOptions }) => {
  return (
    <>
      <Checkbox
        label={label}
        value={value}
        key={value}
        onChange={onChange}
        checked={!!values.find(item => item == value)}
        marginBottom={1}
      />
      {!!childrenOptions.length && (
        <ChildrenWrap>
          {childrenOptions.map(({ label, value, children }) => (
            <FilterItem
              label={label}
              value={value}
              key={value}
              onChange={onChange}
              checked={!!values.find(item => item == value)}
              values={values}
              childrenOptions={children}
            />
          ))}
        </ChildrenWrap>
      )}
    </>
  )
}

FilterItem.propTypes = {
  onChange: func,
  values: array,
  label: string,
  value: any,
  childrenOptions: array,
}

const ChildrenWrap = styled.div`
  padding-left: 0.5rem;
`
